import { SerializePayload } from 'app/area/search-filters/types';
import { serializeCodes, serializePredefined } from 'app/area/search-filters/serialize/serialize';
import { ListBranchModel } from 'app/area/subscriber-groups/user-members/types-store';

export const serialize = (dataToSerialize: SerializePayload): ListBranchModel => {

  const { formValues, menuValues, filters, filterValidation } = dataToSerialize;

  return {
    ...serializeCodes(formValues, menuValues, filters, filterValidation),
    ...serializePredefined(formValues)
  };
};
